import React from 'react';
import styled from 'styled-components';
import {
  SectionParent,
  H1,
  H2,
  H3,
  B1,
  BlueButton,
} from '../../StyledComponents';
import AppDevice from '../../../assets/Test/AppDevice.svg';
import ADB from '../../../assets/Test/avd_hardware.svg';
import AppVerify from '../../../assets/Test/AppVerify.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import Alerts from '../../../assets/Retail/alerts.svg';
import { navigate } from '@reach/router';

const Section = styled(SectionParent)`
  padding: 0rem 20rem;
  display: grid;
  justify-items: center;
  width: 100%;
  background-color: #f9fdfb;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding: 0rem 16rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding: 0rem 10rem;
  }
  @media (max-width: 768px) {
    padding-top: 9px;
    padding-left: 4rem;
    padding-right: 4rem;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    padding-bottom: 2rem;
  }
`;
const SecondSection = styled.div`
  padding: 2rem 4rem;
  background-color: #000000;
  display: flex;
  justify-content: center;
  @media (max-width: 520px) {
    display: grid;
    padding: 1rem;
  }
`;
const SecondText = styled(H2)`
  color: white;
  text-align: center;
  align-self: center;
  padding-right: 1rem;
  font-weight: bold;
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 520px) {
    padding: 0 2rem;
    padding-bottom: 1rem;
  }
  @media (max-width: 350px) {
    padding: 0 1rem;
  }
`;
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  padding-left: 5rem;
  padding-right: 5rem;
  justify-content: center;
  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
  @media (max-width: 520px) {
    padding-left: 0rem;
    padding-right: 0rem;
    padding-top: 0rem;
  }
`;

const GridItem = styled.div`
  grid-column: span 1;
  padding: 2rem;
  min-width: 220px;
  /* margin-right: 1rem;
  margin-left: 1rem; */
  @media (max-width: 768px) {
    padding-top: 4rem;
    flex: 0 0 calc(100%);
    padding-right: 10%;
    padding-left: 10%;
    display: grid;
    justify-items: center;
  }
  @media (max-width: 520px) {
    padding: 1rem;
    min-width: unset;
  }
`;

const GridItemTitle = styled(H2)`
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #1b2341;

  min-height: 3rem;
  margin-top: 0.5rem;
  margin-bottom: 0.8rem;
  @media (max-width: 1700px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    min-height: 0;
  }
  @media (max-width: 520px) {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    font-size: 16px;
  }
  @media (max-width: 375px) {
    font-size: 15px;
  }
`;
const imageStyle = {
  height: '98px',
  width: '86px',
};

const ImgContainer = styled.div`
  display: grid;
  justify-items: center;
`;
const BottomButton = styled(BlueButton)`
  background-color: #725cbd;
`;
const BlueButtonWrapper = styled.div`
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    justify-self: center;
    margin-bottom: 0;
  }
`;
const SectionTitle = styled(H1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 500;
  font-style: normal;
  margin-top: 3rem;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #725cbd;
  @media (max-width: 520px) {
    padding: 0 1rem;
  }
`;
export default () => (
  <div>
    <Section>
      <SectionTitle>
        Benefits Of Using Esper Custom Device Emulators
      </SectionTitle>
      <GridContainer>
        <GridItem>
          <ImgContainer>
            <LazyLoadImage
              alt=" Eliminate App-to-Device compatibility issues"
              src={AppDevice}
              style={imageStyle}
            />
          </ImgContainer>
          <GridItemTitle>
            Eliminate App-to-Device
            <br /> compatibility issues
          </GridItemTitle>
        </GridItem>
        <GridItem>
          <ImgContainer>
            <LazyLoadImage
              alt="Provision your AVD to mirror target hardware provisioning"
              src={ADB}
              style={imageStyle}
            />
          </ImgContainer>
          <GridItemTitle>
            Provision your AVD to mirror target hardware provisioning
          </GridItemTitle>
        </GridItem>
        <GridItem>
          <ImgContainer>
            <LazyLoadImage
              alt=" Streamline process for application verification and roll-out"
              src={AppVerify}
              style={imageStyle}
            />
          </ImgContainer>
          <GridItemTitle>
            Streamline process for application
            <br /> verification and roll-out
          </GridItemTitle>
        </GridItem>
      </GridContainer>
    </Section>
    <SecondSection>
      <SecondText>
        Reduce bugs and failures in the field by up to 80%!
      </SecondText>

      <BlueButtonWrapper>
        <BottomButton
          id="test__test_application"
          onClick={() => navigate('/signup')}
        >
          {' '}
          Test application
        </BottomButton>
      </BlueButtonWrapper>
    </SecondSection>
  </div>
);
